/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable func-names */
/* eslint-disable indent */
/* eslint-disable eqeqeq */
import React, { createContext, useEffect, useState } from "react";
import utils from "../../utils";
//import MySpinner from "components/Spinner";
import MySpinner from "../../components/Spinner";

const { rest } = utils;
const UmbracoContext = createContext();

const UmbracoStep = (context, step) =>
  context.children[0]?.children?.find((x) => x.name == step)?.properties;
  const UmbracoStepChildren = (context, step) =>{
    return context.steps?.Children?.find(
      x => x.Name === step,
    )?.Children;
  }

const UmbracoUpStep = (context, step) =>
  context.children?.find((x) => x.name == step)?.properties;

const UmbracoChildren = (context, step) => {
  const childrenList = [];
  const { children } = context.children[0].children.find((x) => x.name == step);
  children.map(function (item) {
    childrenList.push(item.properties);
  });
  return childrenList;
};

const UmbracoDirectChildren = (context) => {
  const childrenList = [];
  const children  = context.children;
  children.map(function (item) {
    childrenList.push(item.properties);
  });
  return childrenList;
};

const UmbracoProvider = ({ children, umbracoUrl, noSpiner }) => {
  const [resource, setResource] = useState();
  const [footerHeader, setFooterHeader] = useState();
  useEffect(() => {
    getUmbraco();
  }, []);
  const getUmbraco = async () => {
    const inner_resource = await rest.get(umbracoUrl);
    setResource(inner_resource.data.content);
    const resourceF = await rest.get("/api/General/GetPageCms");
    setFooterHeader(resourceF);
  };
  if (resource !== undefined && footerHeader !== undefined)
    return (
      <UmbracoContext.Provider value={{ resource, footerHeader }}>
        {children}
      </UmbracoContext.Provider>
    );
  return (noSpiner ? "" : <MySpinner />);
};

export { UmbracoContext, UmbracoProvider, UmbracoStep, UmbracoChildren,UmbracoStepChildren, UmbracoUpStep, UmbracoDirectChildren };
